// extracted by mini-css-extract-plugin
export default {"headline":"FosterInfoPage_headline__7zgND","content":"FosterInfoPage_content__O5dRh"};